var EHDI = EHDI || Object.create(null);

EHDI.popup = EHDI.popup || Object.create(null);

EHDI.popup.CatchlistPopup = function( type, common, uncommon, rare ) {
    EHDI.aka.Container.call(this);
    
    var _this = this;
    var _type = type;
    var _isArabic = ( EHDI.GAME.localeID === "ar" ) ? true : false;
    
    var _commonData = common,
        _unCommonData = uncommon,
        _rareData = rare;
    
    var _fishListData = [],
        _powerListData = [],
        _junkListData = [],
        _achieveListData = [];
    
    var _shownListHeight, _shownListPosition;
    var _fishList, _powerList, _junkList, _achieveList;
    var _currentList;
    
    var _touchLayer,
        _isScrollActive = false,
        _touchDown = false,
        _scrollPointerDown = false,
        _prevPointerY = 0,
        _prevScrollPointerY = 0,
        _scrollVelocity = 0,
        _touchID = 0,
        _scrollTouchID = 0,
        _shownList,
        _shownListHeight = 0,
        _shownListPosition = 0;
    
    var _upButton, _downButton, _scrollCont, _scroller;
    var _upButtonDown = false, 
        _downButtonDown = false;
    
    var _closeButton, _fishButton, _powerButton, _junkButton;
    
    this.popUpWillAppear = function() {
        if( _type === 0 )   createFishList();
        else                createAchievement();
        
        _touchLayer = new EHDI.aka.Sprite( EHDI.displays.TextureRectangle( 0x000000, EHDI.screen.stageWidth, EHDI.screen.stageHeight ) );
        _touchLayer.anchor.set( 0.5, 0.5 );
        _touchLayer.alpha = 0;
        _this.addChild( _touchLayer );
        
        _touchLayer.interactive = true;
        _touchLayer.touchstart = _touchLayer.mousedown = onDown;
        _touchLayer.touchmove = _touchLayer.mousemove = onMove;
        _touchLayer.touchend = _touchLayer.mouseup = _touchLayer.touchendoutside = _touchLayer.mouseupoutside = onRelease;
        
        _closeButton = new EHDI.displays.Button( EHDI.Assets.images["btn_back"], null, null, null, 0.8 );
        _closeButton.position.set( EHDI.screen.viewWidth * -0.425, EHDI.screen.viewHeight * -0.375 );
        _closeButton.setOnClickFunction( closeList );
        
        _fishButton = new EHDI.displays.Button( EHDI.Assets.images["btn_fishes_idle"], null, null, EHDI.Assets.images["btn_fishes_active"], 0.8 );
        _fishButton.position.set( EHDI.screen.viewWidth * -0.425, EHDI.screen.viewHeight * -0.175 );
        _fishButton.setOnClickFunction( showList, [0] );
        
        _powerButton = new EHDI.displays.Button( EHDI.Assets.images["btn_powerups_idle"], null, null, EHDI.Assets.images["btn_powerups_active"], 0.8 );
        //_powerButton.position.set( EHDI.screen.viewWidth * -0.425, EHDI.screen.viewHeight * -0.025 );
        _powerButton.position.x = _fishButton.position.x;
        _powerButton.position.y = _fishButton.position.y + _fishButton.height * 0.9;
        _powerButton.setOnClickFunction( showList, [1] );
        
        _junkButton = new EHDI.displays.Button( EHDI.Assets.images["btn_junk_idle"], null, null, EHDI.Assets.images["btn_junk_active"], 0.8 );
        //_junkButton.position.set( EHDI.screen.viewWidth * -0.425, EHDI.screen.viewHeight * 0.125 );
        _junkButton.position.x = _powerButton.position.x;
        _junkButton.position.y = _powerButton.position.y + _powerButton.height * 0.9;
        _junkButton.setOnClickFunction( showList, [2] );
        
        createScrollbar();
        
        var curList;
        if( _type === 0 ){
            _fishButton.disable( true );
            curList = _fishList;
        }
        else{
            _fishButton.visible = false;
            _powerButton.visible = false;
            _junkButton.visible = false;
            curList = _achieveList;
        }
        
        _this.addChild( curList );
        curList.showAllChildren();
        curList.position.y = EHDI.screen.stageHeight * -0.5;
        _shownList = curList;
        _shownListHeight = curList.height;
        _shownListPosition = 0;
        _shownList.scroll( _shownListPosition );
        _scroller.position.y = 0;
        _scrollVelocity = 0;
        
        _this.addChild( _closeButton );
        _this.addChild( _fishButton );
        _this.addChild( _powerButton );
        _this.addChild( _junkButton );
        
        EHDI.GAME.updateManager.addFrameListener( scrollUpdate );
    }
    
    var createAchievement = function(){
        var achieveData = EHDI.Assets.fetch( "achievement_data" );
        var achieveStatus = EHDI.GAME.achieveManager.getUnlockedStates();
        
        for( var i = 0; i < achieveData.achievement.length; i++ ){
            var curData = achieveData.achievement[ i ];
            var data = { id: -1, icon: "", status : false };
            
            data.id = curData.id;
            data.icon = curData.icon;
            data.status = achieveStatus[ i ];
            _achieveListData.push( data );
        }
        
        createAchieveList();
    }
    
    var createFishList = function(){
        for( var i = 0; i < _commonData.fish.length; i++ ){ _fishListData.push( _commonData.fish[ i ] ); }
        for( var i = 0; i < _unCommonData.fish.length; i++ ){ _fishListData.push( _unCommonData.fish[ i ] ); }
        for( var i = 0; i < _rareData.fish.length; i++ ){ _fishListData.push( _rareData.fish[ i ] ); }
        
        _fishList = new EHDI.component.BackgroundScrollManager();
        
        var posY = 0;
        var sectionCount = _fishListData.length + 2;
        for( var i = 0; i < sectionCount; i++ ){
            var bgTexture = "inventory_";
            if( i === 0 )                       bgTexture += "top";
            else if( i === sectionCount - 1 )   bgTexture += "bottom";
            else                                bgTexture += "middle";
            
            var bgSection = new EHDI.aka.Sprite( EHDI.Assets.images[ bgTexture ] );
            bgSection.position.y = posY;
            _fishList.addChild( bgSection );
            
            if( i !== 0 && i !== sectionCount - 1 ){
                var curFishData = _fishListData[ i - 1 ];
                var storedFishData = EHDI.GAME.dataManager.getData().fish[ curFishData.id ];
                var frame = new EHDI.aka.Sprite( EHDI.Assets.images[ "inventory_frame1" ] );
                frame.position.set( bgSection.width * 0.075, 0 );
                bgSection.addChild( frame );
                
                var mask = new EHDI.aka.Graphics();
                mask.beginFill( 0x000000 );
                mask.drawRect( 0, 0, frame.width * 0.81, frame.height * 0.61 );
                mask.endFill();
                mask.position.set( frame.width * 0.49 - mask.width * 0.5, frame.height * 0.45 - mask.height * 0.5 );
                frame.addChild( mask );
                
                var fish = new EHDI.aka.Sprite( EHDI.Assets.images[ curFishData.asset ] );
                fish.scale.set( 0.32 );
                fish.anchor.set( 0.5, 0.5 );
                fish.rotation = -Math.PI/2;
                fish.mask = mask;
                fish.position.set( frame.width * 0.51, frame.height * 0.49 );
                frame.addChild( fish );
                if( !storedFishData.caught ) fish.texture = EHDI.Assets.images[ "shdw_" + curFishData.asset ];

                var name = EHDI.localization.strings[ "fishlist" ].content;
                name = name.replace( "[name]", storedFishData.name );
                
                var weight = EHDI.localization.strings[ "fishweight" ].content;
                if( storedFishData.weight === 0 ){
                    weight = weight.replace( "[weight]", "??" );
                }
                else{
                    weight = weight.replace( "[weight]", storedFishData.weight );
                }

                var nameLabel = new EHDI.aka.PixiText( name, {
                    fontFamily: "nuevastd-bold", 
                    fontSize: EHDI.localization.strings[ "fishlist" ].size, 
                    align: 'center', 
                    fill: '#000000' 
                });
                nameLabel.anchor.set( 0.0, 0.5 );
                nameLabel.position.set( frame.position.x + frame.width * 1.05, bgSection.height * 0.25 );
                bgSection.addChild( nameLabel );

                var weightLabel = new EHDI.aka.PixiText( weight, {
                    fontFamily: "nuevastd-bold", 
                    fontSize: EHDI.localization.strings[ "fishweight" ].size, 
                    align: 'center', 
                    fill: '#000000' 
                });
                weightLabel.anchor.set( 0.0, 0.5 );
                weightLabel.position.set( frame.position.x + frame.width * 1.05, bgSection.height * 0.5 );
                bgSection.addChild( weightLabel );

                if( _isArabic ){
                    nameLabel.anchor.set( 1.0, 0.5 );
                    nameLabel.position.x = bgSection.width * 0.925;

                    weightLabel.anchor.set( 1.0, 0.5 );
                    weightLabel.position.x = bgSection.width * 0.925;
                }
                
                var trophyAsset = "trophy_" + ( (curFishData.baseWeight * 2).toFixed(1) === storedFishData.weight ? "sign" : "shdw" );
                var trophy = new EHDI.aka.Sprite( EHDI.Assets.images[ trophyAsset ] );
                trophy.anchor.set( 0.5, 1.0 );
                trophy.position.set( frame.width * 0.5, frame.height * 0.98 );
                frame.addChild( trophy );
            }
            
            posY += bgSection.height;
        }
        
        _fishList.position.x = _fishList.width * -0.5;
    }
    
    var createPowerList = function(){
        for( var i = 0; i < _commonData.powerup.length; i++ ){ _powerListData.push( _commonData.powerup[ i ] ); }
        for( var i = 0; i < _unCommonData.powerup.length; i++ ){ _powerListData.push( _unCommonData.powerup[ i ] ); }
        for( var i = 0; i < _rareData.powerup.length; i++ ){ _powerListData.push( _rareData.powerup[ i ] ); }
        
        _powerList = new EHDI.component.BackgroundScrollManager();
        
        var posY = 0;
        var sectionCount = _powerListData.length + 2;
        for( var i = 0; i < sectionCount; i++ ){
            var bgTexture = "inventory_";
            if( i === 0 )                       bgTexture += "top";
            else if( i === sectionCount - 1 )   bgTexture += "bottom";
            else                                bgTexture += "middle";
            var bgSection = new EHDI.aka.Sprite( EHDI.Assets.images[ bgTexture ] );
            bgSection.position.y = posY;
            _powerList.addChild( bgSection );
            
            if( i !== 0 && i !== sectionCount - 1 ){
                var curPowerData = _powerListData[ i - 1 ];
                var frame = new EHDI.aka.Sprite( EHDI.Assets.images[ "inventory_frame1" ] );
                frame.position.set( bgSection.width * 0.075, 0 );
                bgSection.addChild( frame );

                var mask = new EHDI.aka.Graphics();
                mask.beginFill( 0x000000 );
                mask.drawRect( 0, 0, frame.width * 0.81, frame.height * 0.61 );
                mask.endFill();
                mask.position.set( frame.width * 0.49 - mask.width * 0.5, frame.height * 0.45 - mask.height * 0.5 );
                frame.addChild( mask );
                
                var power = new EHDI.aka.Sprite( EHDI.Assets.images[ curPowerData.asset ] );
                power.scale.set( 0.5 );
                power.anchor.set( 0.5, 0.5 );
                power.mask = mask;
                power.position.set( frame.width * 0.49, frame.height * 0.465 );
                frame.addChild( power );
                
                var name = EHDI.localization.strings[ "powlist" ].content;
                name = name.replace( "[name]", EHDI.localization.strings[ "pow_name_" + (i - 1) ].content );
                
                var desc = EHDI.localization.strings[ "powdesc" ].content;
                desc = desc.replace( "[desc]", EHDI.localization.strings[ "pow_desc_" + (i - 1) ].content );

                var nameLabel = new EHDI.aka.PixiText( name, {
                    fontFamily: "nuevastd-bold", 
                    fontSize: EHDI.localization.strings[ "powlist" ].size, 
                    align: 'center', 
                    fill: '#000000' 
                });
                nameLabel.anchor.set( 0.0, 0.5 );
                nameLabel.position.set( frame.position.x + frame.width * 1.05, bgSection.height * 0.25 );
                bgSection.addChild( nameLabel );
                
                var descLabel = new EHDI.aka.PixiText( desc, {
                    fontFamily: "nuevastd-bold", 
                    fontSize: EHDI.localization.strings[ "powdesc" ].size, 
                    align: _isArabic ? 'right' : 'left', 
                    fill: '#000000',
                    wordWrap: true,
                    wordWrapWidth: bgSection.width * 0.55,
                    lineHeight: 40
                });
                descLabel.position.set( frame.position.x + frame.width * 1.05, bgSection.height * 0.435 );
                bgSection.addChild( descLabel );

                if( _isArabic ){
                    nameLabel.anchor.set( 1.0, 0.5 );
                    nameLabel.position.x = bgSection.width * 0.925;

                    descLabel.anchor.set( 1.0, 0.0 );
                    descLabel.position.x = bgSection.width * 0.925;
                }
            }
            
            posY += bgSection.height;
        }
        
        _powerList.position.x = _powerList.width * -0.5;
        //_this.addChild( _powerList );
    }
    
    var createJunkList = function(){
        for( var i = 0; i < _commonData.junk.length; i++ ){ _junkListData.push( _commonData.junk[ i ] ); }
        for( var i = 0; i < _unCommonData.junk.length; i++ ){ _junkListData.push( _unCommonData.junk[ i ] ); }
        for( var i = 0; i < _rareData.junk.length; i++ ){ _junkListData.push( _rareData.junk[ i ] ); }
        
        _junkList = new EHDI.component.BackgroundScrollManager();
        
        var posY = 0;
        var sectionCount = _junkListData.length + 2;
        for( var i = 0; i < sectionCount; i++ ){
            var bgTexture = "inventory_";
            if( i === 0 )                       bgTexture += "top";
            else if( i === sectionCount - 1 )   bgTexture += "bottom";
            else                                bgTexture += "middle";
            
            var bgSection = new EHDI.aka.Sprite( EHDI.Assets.images[ bgTexture ] );
            bgSection.position.y = posY;
            _junkList.addChild( bgSection );
            
            if( i !== 0 && i !== sectionCount - 1 ){
                var curJunkData = _junkListData[ i - 1 ];
                var storedJunkData = EHDI.GAME.dataManager.getData().junk[ curJunkData.id ];
                var frame = new EHDI.aka.Sprite( EHDI.Assets.images[ "inventory_frame2" ] );
                frame.position.set( bgSection.width * 0.075, 0 );
                bgSection.addChild( frame );

                var mask = new EHDI.aka.Graphics();
                mask.beginFill( 0x000000 );
                mask.drawRect( 0, 0, frame.width * 0.81, frame.height * 0.61 );
                mask.endFill();
                mask.position.set( frame.width * 0.49 - mask.width * 0.5, frame.height * 0.45 - mask.height * 0.5 );
                frame.addChild( mask );
                
                var junk = new EHDI.aka.Sprite( EHDI.Assets.images[ curJunkData.asset ] );
                junk.scale.set( 0.6 );
                junk.anchor.set( 0.5, 0.5 );
                junk.rotation = -Math.PI/2;
                junk.mask = mask;
                junk.position.set( frame.width * 0.49, frame.height * 0.465 );
                frame.addChild( junk );
                if( !storedJunkData.caught ) junk.texture = EHDI.Assets.images[ "shdw_" + curJunkData.asset ];
                
                var name = EHDI.localization.strings[ "junklist" ].content;
                name = name.replace( "[name]", storedJunkData.name );
                
                var weight = EHDI.localization.strings[ "junkweight" ].content;
                if( storedJunkData.weight === 0 ){
                    weight = weight.replace( "[weight]", "??" );
                }
                else{
                    weight = weight.replace( "[weight]", storedJunkData.weight );
                }

                var nameLabel = new EHDI.aka.PixiText( name, {
                    fontFamily: "nuevastd-bold", 
                    fontSize: EHDI.localization.strings[ "junklist" ].size, 
                    align: 'center', 
                    fill: '#000000' 
                });
                nameLabel.anchor.set( 0.0, 0.5 );
                nameLabel.position.set( frame.position.x + frame.width * 1.05, bgSection.height * 0.25 );
                bgSection.addChild( nameLabel );

                var weightLabel = new EHDI.aka.PixiText( weight, {
                    fontFamily: "nuevastd-bold", 
                    fontSize: EHDI.localization.strings[ "junkweight" ].size, 
                    align: 'center', 
                    fill: '#000000' 
                });
                weightLabel.anchor.set( 0.0, 0.5 );
                weightLabel.position.set( frame.position.x + frame.width * 1.05, bgSection.height * 0.5 );
                bgSection.addChild( weightLabel );

                if( _isArabic ){
                    nameLabel.anchor.set( 1.0, 0.5 );
                    nameLabel.position.x = bgSection.width * 0.925;

                    weightLabel.anchor.set( 1.0, 0.5 );
                    weightLabel.position.x = bgSection.width * 0.925;
                }
            }
            
            posY += bgSection.height;
        }
        
        _junkList.position.x = _junkList.width * -0.5;
        //_this.addChild( _junkList );
    }
    
    var createAchieveList = function(){
        _achieveList = new EHDI.component.BackgroundScrollManager();
        
        var posY = 0;
        var sectionCount = _achieveListData.length + 2;
        for( var i = 0; i < sectionCount; i++ ){
            var bgTexture = "inventory_";
            if( i === 0 )                       bgTexture += "top";
            else if( i === sectionCount - 1 )   bgTexture += "bottom";
            else                                bgTexture += "middle";
            
            var bgSection = new EHDI.aka.Sprite( EHDI.Assets.images[ bgTexture ] );
            bgSection.position.y = posY;
            _achieveList.addChild( bgSection );
            
            if( i !== 0 && i !== sectionCount - 1 ){
                var curAchieveData = _achieveListData[ i - 1 ];
                
                var name = EHDI.localization.strings[ "achieve_name_" + curAchieveData.id ].content;
                var desc = EHDI.localization.strings[ "achieve_desc_" + curAchieveData.id ].content;
                var icon = curAchieveData.icon;
                var status = curAchieveData.status;
                
                var contAsset = ( status ) ? "con_achievement": "con_achievement_dark";
                var container = new EHDI.aka.Sprite( EHDI.Assets.images[ contAsset ] );
                container.anchor.set( 0.5, 0.5 );
                container.position.set( bgSection.width * 0.5, bgSection.height * 0.38 );
                
                if( !status ) icon += "_shdw";
                var achieveIcon = new EHDI.aka.Sprite( EHDI.Assets.images[ icon ] );
                achieveIcon.anchor.set( 0.5, 0.5 );
                achieveIcon.position.x = container.width * -0.38;
                container.addChild( achieveIcon );

                var nameLabel = new EHDI.aka.PixiText( name, {
                    fontFamily: "nuevastd-bold", 
                    fontSize: EHDI.localization.strings["achievelist"].size, 
                    align: 'center', 
                    fill: '#000000' 
                });
                nameLabel.anchor.set( 0.0, 0.5 );
                nameLabel.position.set( container.width * -0.3, container.height * -0.15 );
                container.addChild( nameLabel );

                var descLabel = new EHDI.aka.PixiText( desc, {
                    fontFamily: "nuevastd-bold", 
                    fontSize: EHDI.localization.strings["achievelist"].size - 2, 
                    align: 'left',
                    wordWrap: true,
                    wordWrapWidth: container.width * 0.75,
                    fill: '#000000' 
                });
                descLabel.anchor.set( 0.0, 0.5 );
                descLabel.position.set( container.width * -0.3, container.height * 0.15 );
                container.addChild( descLabel );
                
                var progressBar = new EHDI.aka.Sprite( EHDI.Assets.images[ "achievement_bar" ] );
                progressBar.anchor.set( 0.5, 0.5 );
                progressBar.position.set( bgSection.width * 0.5, bgSection.height * 0.765 );
                
                var fillBar = new  EHDI.aka.Sprite( EHDI.displays.TextureRectangle( 0x00FF00, progressBar.width * 0.98, progressBar.height * 0.95 ) );
                fillBar.anchor.set( 0, 0.5 );
                fillBar.position.x = progressBar.position.x - fillBar.width * 0.5;
                fillBar.position.y = progressBar.position.y;
                
                var progressData = EHDI.GAME.achieveManager.checkAchievementProgress( i - 1 );
                fillBar.scale.x = progressData.count / progressData.goal;
                
                var progressLabel = new EHDI.aka.PixiText( progressData.count + " / " + progressData.goal, {
                    fontFamily: "nuevastd-bold", 
                    fontSize: 19, 
                    align: 'center', 
                    fill: '#000000' 
                });
                progressLabel.anchor.set( 0.5, 0.46 );
                progressLabel.position.set( progressBar.position.x, progressBar.position.y );
                
                bgSection.addChild( fillBar );
                bgSection.addChild( progressBar );
                bgSection.addChild( progressLabel );
                bgSection.addChild( container );
            }
            
            posY += bgSection.height;
        }
        
        _achieveList.position.x = _achieveList.width * -0.5;
    }
    
    var createScrollbar = function(){
        _upButton = new EHDI.aka.Sprite( EHDI.Assets.images["btn_up_scroll"] );
        _upButton.position.set( EHDI.screen.viewWidth * 0.425, EHDI.screen.viewHeight * -0.325 );
        _upButton.anchor.set( 0.5, 0.5 );
        
        _downButton = new EHDI.aka.Sprite( EHDI.Assets.images["btn_down_scroll"] );
        _downButton.position.set( EHDI.screen.viewWidth * 0.425, EHDI.screen.viewHeight * 0.375 );
        _downButton.anchor.set( 0.5, 0.5 );
        
        var upButtonPointerDown = function() {
            EHDI.GAME.soundManager.playSFX("button_01");
            _upButtonDown = true;
            _upButton.scale.set(0.95);
            _scrollVelocity = 0;
        }
        
        var downButtonPointerDown = function() {
            EHDI.GAME.soundManager.playSFX("button_01");
            _downButtonDown = true;
            _downButton.scale.set(0.95);
            _scrollVelocity = 0;
        }
        
        var upButtonPointerUp = function() {
            _upButtonDown = false;
            _upButton.scale.set(1);
        }
        
        var downButtonPointerUp = function() {
            _downButtonDown = false;
            _downButton.scale.set(1);
        }
        
        _upButton.interactive = true;
        _upButton.touchstart = _upButton.mousedown = upButtonPointerDown;
        _upButton.touchend = _upButton.mouseup = _upButton.mouseupoutside = _upButton.touchendoutside = upButtonPointerUp;
        
        _downButton.interactive = true;
        _downButton.touchstart = _downButton.mousedown = downButtonPointerDown;
        _downButton.touchend = _downButton.mouseup = _downButton.mouseupoutside = _downButton.touchendoutside = downButtonPointerUp;
        
        _scrollCont = new EHDI.aka.TilingSprite( 
            EHDI.Assets.images["nav_bar"], 
            50, 
            _downButton.position.y - _upButton.position.y - _upButton.height * 0.95
        );
        _scrollCont.position.set( EHDI.screen.viewWidth * 0.425 - _scrollCont.width * 0.5, _upButton.y + _upButton.height * 0.475 );
        _this.addChild( _scrollCont );
        _this.addChild( _upButton );
        _this.addChild( _downButton );
        _scrollCont.interactive = true;
        
        var onScrollDown = function(e) {
            if( _scrollPointerDown || _touchDown ) return;
            
            _scrollTouchID = e.data.identifier;
            _scrollPointerDown = true;
            _prevScrollPointerY = e.data.global.y / EHDI.GAME.scaleManager.getScale();
            _scrollVelocity = 0;
        }
        
        var onScrollMove = function(e){
            if( _scrollTouchID !== e.data.identifier || !_scrollPointerDown ) return;
            
            var deltaY = (e.data.global.y / EHDI.GAME.scaleManager.getScale()) - _prevScrollPointerY;
            if(_scroller.position.y + deltaY > 0 && _scroller.position.y + deltaY < (_scrollCont.height - _scroller.height)){
                _scroller.position.y += deltaY;
            } else if(_scroller.position.y + deltaY >= (_scrollCont.height - _scroller.height)){
                _scroller.position.y = _scrollCont.height - _scroller.height;
            } else {
                _scroller.position.y = 0;
            }
            
            _prevScrollPointerY = (e.data.global.y / EHDI.GAME.scaleManager.getScale());
            _shownListPosition = _scroller.position.y / (_scrollCont.height - _scroller.height) *  (_shownListHeight - EHDI.screen.stageHeight);
            _shownList.scroll(-_shownListPosition);
        }
        
        var onScrollUp = function(e) {
            if( _scrollTouchID !== e.data.identifier ) return;
            
            _scrollTouchID = -1;
            _scrollPointerDown = false;
        }
        
        _scroller = new EHDI.aka.Sprite( EHDI.Assets.images["nav_indicator"] );
        _scroller.anchor.set( 0.5, 0 );
        _scroller.position.set( _scrollCont.width * 0.5, 0 );
        _scrollCont.addChild( _scroller );
        
        _scroller.interactive = true;
        _scroller.touchstart = _scroller.mousedown = onScrollDown;
        _scroller.touchmove = _scroller.mousemove = onScrollMove;
        _scroller.touchend = _scroller.mouseup = _scroller.mouseupoutside = _scroller.touchendoutside = onScrollUp;
        
        EHDI.GAME.updateManager.addFrameListener( buttonUpdate );
    }
        
    var showList = function( index ){
        _fishButton.disable( false );
        _powerButton.disable( false );
        _junkButton.disable( false );
        
        if( _fishList ) _this.removeChild( _fishList );
        
        if( _powerList ) 
            _this.removeChild( _powerList );
        else
            createPowerList();
            
        if( _junkList ) 
            _this.removeChild( _junkList );
        else
            createJunkList();
        
        if( _achieveList ) _this.removeChild( _achieveList );
        
        var curList;
        switch( index ){
            case 0: curList = _fishList; _fishButton.disable( true ); break;
            case 1: curList = _powerList; _powerButton.disable( true ); break;
            case 2: curList = _junkList; _junkButton.disable( true ); break;
            case 3: curList = _achieveList; break;
        }
        
        EHDI.GAME.soundManager.playSFX("button_01");
        _this.addChild( curList );
        curList.showAllChildren();
        curList.position.y = EHDI.screen.stageHeight * -0.5;
        _shownList = curList;
        _shownListHeight = curList.height;
        _shownListPosition = 0;
        _shownList.scroll( _shownListPosition );
        _scroller.position.y = 0;
        _scrollVelocity = 0;
    }
    
    var onDown = function(e) {
        //if( _touchDown || _scrollPointerDown ) return;
        
        _touchDown = true;
        _touchID = e.data.identifier;
        _prevPointerY = e.data.global.y / EHDI.GAME.scaleManager.getScale();
        _scrollVelocity = 0;
    }
    
    var onMove = function(e) {
        if( _touchID !== e.data.identifier || !_touchDown ) return;
        
        var deltaY = ( e.data.global.y / EHDI.GAME.scaleManager.getScale() ) - _prevPointerY;
        if( _shownListPosition - deltaY < _shownListHeight - EHDI.screen.stageHeight && _shownListPosition - deltaY > 0 ) {
            _shownListPosition -= deltaY;
            _scrollVelocity = deltaY * 0.8 + _scrollVelocity * 0.2;
        } else if( _shownListPosition - deltaY >= _shownListHeight - EHDI.screen.stageHeight ) {
            _shownListPosition = _shownListHeight - EHDI.screen.stageHeight;
            _scrollVelocity = 0;
        } else {
            _shownListPosition = 0;
            _scrollVelocity = 0;
        }
        _shownList.scroll( -_shownListPosition );
        _prevPointerY = ( e.data.global.y / EHDI.GAME.scaleManager.getScale() );
        
        _scroller.position.y = _shownListPosition / (_shownListHeight - EHDI.screen.stageHeight) * (_scrollCont.height - _scroller.height);
    }

    var onRelease = function(e) {
        //if( _touchID !== e.data.identifier ) return;
        
        _touchDown = false;
        _touchID = -1;
    }
        
    var buttonUpdate = function(dt) {
        var speed = 100;
        
        if(_upButtonDown) 
            speed *= -1;
        else if(!_downButtonDown && !_upButtonDown)
            speed = 0;
        speed *= dt / 1000;
        if(speed !== 0) {
            if(_scroller.position.y + speed > 0 && _scroller.position.y + speed < (_scrollCont.height - _scroller.height)) {
                _scroller.position.y += speed;
            } else if(_scroller.position.y + speed >= (_scrollCont.height - _scroller.height)){
                _scroller.position.y = _scrollCont.height - _scroller.height;
            } else {
                 _scroller.position.y = 0;
            }
            _shownListPosition = _scroller.position.y / (_scrollCont.height - _scroller.height) *  (_shownListHeight - EHDI.screen.stageHeight);
            _shownList.scroll(-_shownListPosition);
        }
    }
    
    var scrollUpdate = function(dt) {
        if( _scrollVelocity === 0 || _touchDown ) return;
        
        if( _scrollVelocity < 0 && _shownListPosition - _scrollVelocity > _shownListHeight - EHDI.screen.stageHeight ) {
            _scrollVelocity = ( ( _shownListHeight - EHDI.screen.stageHeight ) - _shownListPosition );
        } else if( _scrollVelocity > 0 && _shownListPosition - _scrollVelocity < 0 ) {
            _scrollVelocity = -_shownListPosition;
        }
        
        _shownListPosition -= _scrollVelocity;
        _shownList.scroll( -_shownListPosition );
        
        if( _shownListPosition - _scrollVelocity > _shownListHeight - EHDI.screen.stageHeight || _shownListPosition - _scrollVelocity < 0 ) {
            //_scrollTimeline.kill();
            //_scrollTimeline.clear();
            _scrollVelocity = 0;
        }
        
        _scroller.position.y = _shownListPosition / (_shownListHeight - EHDI.screen.stageHeight) * (_scrollCont.height - _scroller.height);
        
        dt = dt / 1000;
        if( _scrollVelocity < -1 ){
            _scrollVelocity += 15 * dt;
        }
        else if( _scrollVelocity > 1 ){
            _scrollVelocity -= 15 * dt;
        }
        else{
            _scrollVelocity = 0;
        }
    }
    
    this.popUpDidAppear = function() {
        
    }
    
    this.popUpDidDisappear = function() {
        EHDI.GAME.gameScene.pauseManager.isReadyOpen = false;
        EHDI.GAME.gameScene.pauseManager.resumeGame();
    }
    
    var closeList = function() {
        EHDI.GAME.soundManager.playSFX("button_01");
        _closeButton.disable( true );
        EHDI.GAME.updateManager.removeFrameListener( scrollUpdate );
        EHDI.GAME.updateManager.removeFrameListener( buttonUpdate );
        EHDI.GAME.sceneManager.popPopUp(null, true);
    }
    
    this.dispose = function() {
    }
}

EHDI.popup.CatchlistPopup.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.popup.CatchlistPopup.prototype.destroy = function() {
    this.dispose();
    EHDI.aka.Container.prototype.destroy.apply(this, arguments);
}